export default __webpack_public_path__ + "static/MonitorSection_uk-a379ca4be94a66751d615737736428ed.png";